<template>
  <Dialog
    :visible.sync="display"
    :style="{ width: '90vw' }"
    :modal="true"
    :closable="false"
  >
    <div style="height: 300px">
      <Dropdown
        :filter="true"
        :showClear="true"
        :options="drivers"
        optionLabel="name"
        v-model="selectedDriver"
        :placeholder="$t('DriverSelector.SelectDriver')"
      />
    </div>
    <template #header>
      <span>{{ $t("DriverSelector.Driver") }}</span>
    </template>
    <template #footer>
      <Button
        :label="$t('DriverSelector.Save')"
        icon="pi pi-check"
        @click="onClick(true)"
        :disabled="!selectedDriver"
      />
      <Button
        :label="$t('DriverSelector.Cancel')"
        icon="pi pi-times"
        @click="onClick(false)"
        class="p-button-secondary"
      />
    </template>
  </Dialog>
</template>

<script>
import WorkRegistrationService from "../../services/WorkRegistrationService";
export default {
  name: "DriverSelector",
  workRegistrationService: null,
  props: { 
    display: {
    type: Boolean,
    default: false
  }, 
    drivers: null },
  created() {
    this.workRegistrationService = new WorkRegistrationService();
  },
  data() {
    return {
      selectedDriver: null,
    };
  },
  watch: {
    display() {
      this.selectedDriver = null;
    },
  },
  methods: {
    // onClick(value) {
    //   if (value) {
    //     const description = `Bestuurder: ${this.selectedDriver.value}`;
    //     this.workRegistrationService
    //       .updateWorkRegistrationDescription(
    //         this.selectedWorkRegistration.id,
    //         description
    //       )
    //       .then(() => {
    //         this.$emit("confirmed", {
    //           value: value,
    //           driver: this.selectedDriver.value,
    //         });
    //       });
    //   } else {
    //     this.$emit("confirmed", {
    //       value: value,
    //     });
    //   }
    // },
     onClick(value) {
      if (value) {        
        this.$emit("confirmed", {
              value: value,
              driver: this.selectedDriver.value,
            });
         
      } else {
        this.$emit("confirmed", {
          value: value,
        });
      }
    },
  },
};
</script>
